/**
 * 클립보드 복사 함수
 * - https, http에 따른 navigator.clipboard 의 사용여부가 달라집니다.
 * @param {string} text
 * @param {Element} target
 */
export const copyToClipboard = (text, targetDOM = document.body) => {
  const onTextarea = () => {
    const input = document.createElement('input');
    input.style.position = 'fixed';
    input.style.left = '-999999px';
    input.style.top = '-999999px';
    input.value = text;
    targetDOM.appendChild(input);

    input.select();
    input.setSelectionRange(0, 99999);

    document.execCommand('copy');
    targetDOM.removeChild(input);

    return true;
  };

  const onNavigator = async () => {
    await navigator.clipboard.writeText(text).catch(onTextarea);

    return true;
  };

  return onNavigator();
};
